import React, { useState } from "react";
import InputTextfield from "components/common/atoms/InputTextField";
import CloseFile from "static/images/CloseFile";
import FilterIcon from "static/images/FilterIcon";
import { t } from "components/CentralDataMangement/translation/Translation";
import type { FilterSectionProps } from "../annotations/WhatsAppAnnotations";
import MultiSelectAtom from "components/common/atoms/MultiSelectAtom";
import ChatIcon from "static/images/ChatIcon";
import { Link } from "react-router-dom";
import { selectAuth } from "features/auth/AuthSlice";
import { useSelector } from "react-redux/es/hooks/useSelector";



const FilterSection: React.FC<FilterSectionProps> = ({
  filterText,
  onInputFilterChange,
  onSelectFilterChange,
  onClearFilter,
  offices,
}) => {
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const authUser = useSelector(selectAuth);  
  const isInstanceActive = authUser.isInstanceReady ?? false;

  return (
    <div style={{ height: "4vw" }}>
      {isFilterVisible ? (
        <div className="filter-bar" style={{ padding: "1vw 0.5vw 0" }}>
          <div className="d-flex">
            <div className="hideLabel hideHeight pe-0 filter-bar-select marginRightPoint5">
              <MultiSelectAtom
                options={offices}
                value={filterText.office ?? null}
                onChange={(e) => onSelectFilterChange(e, "office")}
                name={"office"}
              />
            </div>
            <div
              className="hideHeight pe-0 marginRightPoint5"
              style={{ width: "40%" }}
            >
              <InputTextfield
                value={filterText.name}
                handleChange={onInputFilterChange}
                placeholder={t("Name")}
                name="name"
              />
            </div>
            <div className="align-self-center">
              <span
                className="cursor-pointer table-action-icons"
                title={t("Clear")}
                onClick={() => {
                  onClearFilter();
                  setIsFilterVisible(false);
                }}
              >
                <CloseFile />
              </span>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ padding: "1vw 1vw 0" }}
        >
          <div className="chat-title color-dark-pink position-relative">
            <span className={` ${isInstanceActive ? "isInstanceActive" : "isInstanceNotActive"} whatsapp-notification whatsapp-notification-chat`} title={`${isInstanceActive ? t("Instance connected") : t("Instance disconnected. Please check with admin")}`}></span>
            {t("Chats")}
          </div>
          <div className="d-flex align-items-center">
            <Link
              to={"/add/whatsapp-user"}
              className="table-action-icons cursor-pointer marginRightPoint5"
              title={t("New chat")}
            >
              <ChatIcon />
            </Link>
            <span
              className="table-action-icons cursor-pointer"
              title={t("Filter")}
              onClick={() => setIsFilterVisible(true)}
            >
              <FilterIcon />
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterSection;
